function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React from 'react';
import { Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr } from '@tapresearch/ui/components';
export var ResultsTableView = function(param) {
    var tableData = param.tableData, tapAnswers = param.tapAnswers, crossTabLabels = param.crossTabLabels, usePercentage = param.usePercentage;
    var orderedData = _to_consumable_array(tableData).reverse();
    return /*#__PURE__*/ React.createElement(Box, {
        "data-testid": "result-table-view",
        flexGrow: 1,
        my: 6,
        overflowX: "scroll",
        overflowY: "scroll",
        maxH: "500px"
    }, /*#__PURE__*/ React.createElement(Table, {
        variant: "simple",
        fontSize: "sm",
        sx: {
            borderCollapse: 'separate',
            borderSpacing: '0'
        }
    }, /*#__PURE__*/ React.createElement(Thead, null, /*#__PURE__*/ React.createElement(Tr, {
        "data-testid": !!crossTabLabels ? 'cross-tab-table-thead' : 'standard-table-thead',
        sx: {
            th: {
                textTransform: 'none',
                color: 'gray.900',
                fontWeight: 'normal',
                fontSize: 'sm',
                letterSpacing: 0,
                position: 'sticky',
                top: 0,
                bg: 'white'
            }
        }
    }, !!crossTabLabels && /*#__PURE__*/ React.createElement(CrossTabTHead, {
        crossTabLabels: crossTabLabels,
        orderedData: orderedData
    }))), /*#__PURE__*/ React.createElement(Tbody, null, !crossTabLabels ? orderedData.map(function(answer, i) {
        var _tapAnswers_find_attributes, _tapAnswers_find;
        var answerId = answer.answer_id;
        var _ref = [
            answer[answerId],
            answer["".concat(answerId, "_total")]
        ], answerPct = _ref[0], answerTotal = _ref[1];
        var answerLabel = (_tapAnswers_find = tapAnswers.find(function(ta) {
            return ta.attributes.id.toString() === answerId;
        })) === null || _tapAnswers_find === void 0 ? void 0 : (_tapAnswers_find_attributes = _tapAnswers_find.attributes) === null || _tapAnswers_find_attributes === void 0 ? void 0 : _tapAnswers_find_attributes.option_text;
        return /*#__PURE__*/ React.createElement(Tr, {
            "data-testid": "standard-table-row",
            key: i
        }, /*#__PURE__*/ React.createElement(Td, {
            w: "50%",
            color: "gray.700"
        }, answerLabel), /*#__PURE__*/ React.createElement(Td, {
            color: "gray.900",
            letterSpacing: "tight"
        }, /*#__PURE__*/ React.createElement(Flex, {
            align: "center"
        }, /*#__PURE__*/ React.createElement(Text, {
            fontWeight: "semibold"
        }, answerTotal || 0), /*#__PURE__*/ React.createElement(Text, {
            fontSize: "sm",
            pl: 2
        }, "(", Number(answerPct || 0).toFixed(2), "%)"))));
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, _to_consumable_array(tapAnswers).reverse().map(function(ta) {
        return /*#__PURE__*/ React.createElement(CrossTabRow, {
            key: ta.id,
            tapAnswer: ta,
            orderedData: orderedData,
            crossTabLabels: crossTabLabels,
            usePercentage: usePercentage
        });
    })))));
};
var CrossTabRow = function(param) {
    var tapAnswer = param.tapAnswer, crossTabLabels = param.crossTabLabels, orderedData = param.orderedData, usePercentage = param.usePercentage;
    var _tapAnswer_attributes = tapAnswer.attributes, answerId = _tapAnswer_attributes.id, answerLabel = _tapAnswer_attributes.option_text;
    return /*#__PURE__*/ React.createElement(Tr, {
        "data-testid": "cross-tab-table-row",
        key: answerId
    }, /*#__PURE__*/ React.createElement(Td, {
        maxW: "50%",
        color: "gray.700"
    }, answerLabel), Object.values(crossTabLabels).map(function(labelText, i) {
        var crossTabValues = orderedData.find(function(param) {
            var answer_id = param.answer_id;
            return answer_id === labelText;
        });
        if (!crossTabValues) return null;
        var answerValue = usePercentage ? crossTabValues["".concat(answerId)] || 0 : crossTabValues["".concat(answerId, "_total")] || 0;
        return /*#__PURE__*/ React.createElement(Td, {
            key: "crossTab-".concat(i),
            letterSpacing: "tight",
            color: !answerValue ? 'gray.300' : 'gray.900',
            fontWeight: "semibold",
            textAlign: "center"
        }, usePercentage ? "".concat(Number(answerValue).toFixed(2), "%") : "".concat(answerValue));
    }));
};
var CrossTabTHead = function(param) {
    var crossTabLabels = param.crossTabLabels, orderedData = param.orderedData;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Th, null), Object.values(crossTabLabels).map(function(labelText, i) {
        var crossTabValues = orderedData.find(function(param) {
            var answer_id = param.answer_id;
            return answer_id === labelText;
        });
        return crossTabValues && /*#__PURE__*/ React.createElement(Th, {
            key: i,
            textAlign: "center",
            color: "gray.700"
        }, labelText);
    }));
};
